import * as React from "react";

const SvgScissors = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M15.121 14.121 20 19M13 12l7-7M13 12l-2.879 2.879M13 12l-2.879-2.879M10.121 14.879a3 3 0 1 0-4.243 4.243 3 3 0 0 0 4.243-4.243ZM10.121 9.121a3 3 0 1 0-4.243-4.243 3 3 0 0 0 4.243 4.243Z" />
    </g>
  </svg>
);

export default SvgScissors;
